import React from 'react';
import styled from 'styled-components';

import ItemWrapper from './ItemWrapper';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    column-gap: 20px;
	row-gap: 40px;
    width: 100%;
	max-width: 1060px;
	justify-items: center;
	margin-top: 100px;
`;

export default function ProductsWrapper(props) {
  	return (
		<Wrapper>
			{
				props.products.map((item, index) => (
					<ItemWrapper key={index} product={item} />
				))
			}
		</Wrapper>
  	);
}
